import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
const FeeTemplete = ({ postData, setPostData, }) => {
  return (
    <>
      <div className="feeCard">
        <div className="fees_left_section">
          <CustomInputs
            name={undefined}
            type={FORM_CONTROLFIELD_TYPES?.TEXT}
            value={postData?.leaseApplicationTemplateSections?.ApplicationFees?.fee}
            labelText={"Application Fee"}
            isFormControl
            maxLength={10}
            onChange={(e) => {
              const inputValue = e.target.value;
              if (/^\d*\.?\d{0,2}$/.test(inputValue)) {
                setPostData((prev) => {
                  const newData = { ...prev };
                  newData.leaseApplicationTemplateSections = {
                    ...prev.leaseApplicationTemplateSections,
                    ApplicationFees: {
                      ...prev.leaseApplicationTemplateSections?.ApplicationFees,
                      fee: inputValue,
                    },
                  };
                  return newData;
                });
              }
            }}
            required
            disabled={undefined}
            placeholder={"Application Fee"}
            myClassName={undefined}
            isError={undefined}
            errorMessages={undefined}
            width={"445px"}
            currencySymbol="$"
            currencyHeight="48px"
          /></div>
        <div className="fees_right_section">
          <CustomInputs
            name="signature"
            type={FORM_CONTROLFIELD_TYPES?.TEXT}
            value={postData?.leaseApplicationTemplateSections?.ApplicationFees?.clause}

            labelText={"Application Fee Clause"}
            isFormControl
            maxLength={500}
            onChange={(e) => {
              setPostData({
                ...postData,
                leaseApplicationTemplateSections: { ...postData.leaseApplicationTemplateSections, ApplicationFees: { ...postData?.leaseApplicationTemplateSections?.ApplicationFees, clause: e.target.value } }

              });
            }}
            required
            disabled={undefined}
            placeholder={"Enter Application Fee Clause"}
            myClassName={undefined}
            isError={undefined}
            errorMessages={undefined}
            width={"445px"}
            currencySymbol="$"
            currencyHeight="48px"
          />
          <div>

          </div>

        </div>
      </div>
    </>
  );
};

export default FeeTemplete;
